import { RessortEntry } from "../helper/interfaces";
import React from "react";
import { AppTheme, ContentType   } from "../helper/enums";
import Breadcrumbs from "./Breadcrumbs";
import Tracking from "./Tracking";
import Seo from "./Seo";
import Og from "./Og";
import { PageContent } from "./shared/PageContent";
import { NoContent } from "./shared/NoContent";
import Traffective from "./Traffective";
import TrackingSnowPlow from "./TrackingSnowPlow";
import Piano from "./Piano";
import RessortComponent from "./RessortComponent";

interface Data {
  entry: RessortEntry | null;
  id?: string;
}

function TrackedRessortComponent(data: Data) {

  const isNN = process.env.NEXT_PUBLIC_APP_THEME === AppTheme.nn;
  // const { debugLog } = React.useContext(AppContext);

  // const { } = useScrollRestoration(
  //   data.id ? `ressort-${data.id}` : 'default-ressort',
  //   'ressort',
  //   {
  //     debounceTime: 200
  //   },
  //   debugLog
  // );
  
  return data.entry && data.entry.status === 200 ? (
    <>
      <Piano article={undefined} showOffer={false} trackingInformation={data.entry?.pageInformation?.trackingInformation} pianoSwitchConfiguration={data.entry?.pageInformation?.pianoSwitchConfiguration}/>
      {data.entry.pageInformation &&
        <>
          <Tracking
            trackingInformation={data.entry.pageInformation.trackingInformation}
          />
          {isNN && <TrackingSnowPlow
            paid={false}
            contentType={ContentType.Ressort}
            trackingInformation={data.entry.pageInformation.trackingInformation}
          />}
          <Traffective
            adInformation={data.entry.pageInformation.adInformation}
          />
          <Seo items={data.entry.pageInformation.seoItems} />
          <Og items={data.entry.pageInformation.ogItems} />
          <Breadcrumbs breadcrumbs={data.entry.pageInformation.breadcrumbs} />
        </>
      }
      <RessortComponent entry={data.entry} id={data.id} />
    </>
  ) : (
    <PageContent>
      <NoContent
        status={data.entry?.status?.toString()}
        text="Kein Inhalt"
      />
    </PageContent>
  );
}

export default TrackedRessortComponent;
